/* global axios */
import ApiClient from './ApiClient';

class LeadAlertsAPI extends ApiClient {
  constructor() {
    super('lead_alerts', { accountScoped: true });
  }

  list({ contactId, status, page = 1 } = {}) {
    return axios.get(this.url, {
      params: {
        contact_id: contactId,
        status,
        page,
      },
    });
  }

  create(leadAlert) {
    return axios.post(this.url, { lead_alert: leadAlert });
  }

  update(id, leadAlert) {
    return axios.patch(`${this.url}/${id}`, { lead_alert: leadAlert });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  matches(id) {
    return axios.get(`${this.url}/${id}/matches`);
  }
}

export default new LeadAlertsAPI();
